import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, ShieldCheck, Package, Diamond, Heart, Star, Gem, Gift } from 'lucide-react';
export function NegroPromo() {
  return <div className="py-8 overflow-hidden" data-id="element-136" data-mp="3jlgrbulm8cvp">
      <div className="mx-auto" data-id="element-137" data-mp="3jmiakmcsc5oi">
        {/* Full-width promotional image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="rounded-2xl overflow-hidden mb-12 shadow-xl" data-id="element-138" data-mp="3enx9kkpplhz0">
          <img src="https://cdn.magicpatterns.com/uploads/sV1Hsh7iK1YpRxxoPkMa5t/ChatGPT_Image_1_may_2026,_21_29_48.png" alt="Kit Negro Luxury — Todo lo que necesitas, siempre contigo" loading="eager" decoding="async" className="w-full h-auto object-cover" style={{
          imageRendering: 'auto',
          WebkitBackfaceVisibility: 'hidden'
        }} data-id="element-139" data-mp="1gvmripch190" />
        </motion.div>

        {/* Text content — light background for contrast */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center max-w-2xl mx-auto bg-white rounded-2xl p-8 md:p-10 mb-8" data-id="element-140" data-mp="1ohvlklyksotw">
          <h3 className="text-2xl md:text-3xl font-serif font-semibold mb-6" style={{
          color: '#1A1A1A'
        }} data-id="element-141" data-mp="15llwl3m4ydv4">
            TODO LO QUE NECESITAS,{' '}
            <span className="italic text-gold" data-id="element-142" data-mp="2zvpjpnxftblc">SIEMPRE CONTIGO</span>
          </h3>

          <div className="space-y-4 font-sans text-base leading-relaxed mb-10" style={{
          color: '#333333'
        }} data-id="element-143" data-mp="33x1es8z2yp0x">
            <p className="font-medium" data-id="element-144" data-mp="bqtvt8eksjje">
              Un kit completo diseñado para mujeres que buscan verse impecables,
              trabajar con seguridad y proyectar una imagen profesional en todo
              momento.
            </p>
            <p data-id="element-145" data-mp="2t9nxgm7jozt">
              No importa dónde estés… todo lo que necesitas está organizado,
              protegido y listo para usar cuando lo necesites.
            </p>
          </div>

          {/* Benefits */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left mb-10" data-id="element-146" data-mp="qom9dv0kaxuy">
            <div className="flex items-start gap-3" data-id="element-147" data-mp="qmjasmlcfwem">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-148" data-mp="loztfdtcn3ig">
                <Briefcase className="w-4 h-4 text-gold" data-id="element-149" data-mp="1j79pew0pbmp6" />
              </div>
              <div data-id="element-150" data-mp="1ecvq4iix4vf8">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-151" data-mp="1ecdk4u6gf2u4">
                  Organización total
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-152" data-mp="1vn9c54tmo2vy">
                  Sin esfuerzo, todo en su lugar
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-153" data-mp="24mmn61xegzis">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-154" data-mp="29mijrg3rpoob">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-155" data-mp="2egd9p19yuzvu" />
              </div>
              <div data-id="element-156" data-mp="2jctwns5fj87c">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-157" data-mp="2jfg2nnco9fng">
                  Protegido y listo
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-158" data-mp="2eqt111fuj2u7">
                  Cada accesorio protegido y listo para usar
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-159" data-mp="2ji1c01wtqw9h">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-160" data-mp="2jjce7xamfvyh">
                <Package className="w-4 h-4 text-gold" data-id="element-161" data-mp="1vujia0u01o3v" />
              </div>
              <div data-id="element-162" data-mp="1rsg3p3c1a3ed">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-163" data-mp="1rsy9orohzvzh">
                  Llévalo contigo
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-164" data-mp="3h5a26a7rstht">
                  A donde quieras sin complicaciones
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-165" data-mp="y1ab5oauenbs">
              <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-166" data-mp="12ytq6qfd744s">
                <Diamond className="w-4 h-4 text-gold" data-id="element-167" data-mp="p0c7j74bghtq" />
              </div>
              <div data-id="element-168" data-mp="ty5ew3hcvhvl">
                <p className="font-semibold text-sm mb-0.5" style={{
                color: '#1A1A1A'
              }} data-id="element-169" data-mp="tzgedr3rq3gw">
                  Imagen profesional
                </p>
                <p className="text-xs" style={{
                color: '#333333'
              }} data-id="element-170" data-mp="17xn5moe7p57l">
                  Proyecta elegancia y profesionalismo
                </p>
              </div>
            </div>
          </div>

          {/* Featured quote */}
          <div className="border-l-2 border-gold pl-5 text-left mb-4" data-id="element-171" data-mp="25dkihq42l7zo">
            <p className="font-serif italic text-lg leading-relaxed font-semibold" style={{
            color: '#1A1A1A'
          }} data-id="element-172" data-mp="2f87vzebcqg2u">
              Trabaja con confianza. Luce profesional. Ten todo bajo control.
            </p>
          </div>
        </motion.div>

        {/* Bottom strip — dark bar with gold accents */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-luxury-dark rounded-xl p-6 border border-gray-800" data-id="element-173" data-mp="20dl8oa9qd9ol">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-174" data-mp="1clmv1jmt728a">
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-175" data-mp="1cl4mpomvgxk0">
              <Heart className="w-4 h-4 text-gold shrink-0" data-id="element-176" data-mp="18lcexe5ayvfp" />
              <span className="text-xs text-gray-300" data-id="element-177" data-mp="3k7oak3i8h0su">
                Ahorra tiempo y trabaja mejor
              </span>
            </div>
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-178" data-mp="3o7ooln1f79zd">
              <Star className="w-4 h-4 text-gold shrink-0" data-id="element-179" data-mp="3t7t53d2bw4pl" />
              <span className="text-xs text-gray-300" data-id="element-180" data-mp="21rsv16mn52d">
                Ideal para profesionales
              </span>
            </div>
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-181" data-mp="30k6uhkuonzt8">
              <Gem className="w-4 h-4 text-gold shrink-0" data-id="element-182" data-mp="35i8kyqufv1eq" />
              <span className="text-xs text-gray-300" data-id="element-183" data-mp="35iry7u9591mf">
                Calidad premium en cada detalle
              </span>
            </div>
            <div className="flex items-center gap-2 justify-center text-center" data-id="element-184" data-mp="3f8tj6d67a3x4">
              <Gift className="w-4 h-4 text-gold shrink-0" data-id="element-185" data-mp="2hsxhh1lpesww" />
              <span className="text-xs text-gray-300" data-id="element-186" data-mp="2hsea2etojmx4">
                Perfecto para ti o para regalar
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}